angular.module('invoice')
    .factory('InvoiceProjectBgt', function ($resource) {
        return $resource('crm/api/invoice-project/:entityId/bgt/:id', { }, {
            'query': { method: 'GET', isArray: true },
            'get': { method: 'GET' },
            'save': { method: 'POST' },
            'update': { method: 'PUT' },
            'delete': { method: 'DELETE' },
            'revisions': {method: 'GET', url: 'crm/api/invoice-project/:entityId/bgt/revisions', isArray: true},
            'createRevision': {method: 'POST', url: 'crm/api/invoice-project/:entityId/bgt/revisions'},
            'publishRevision': {method: 'PUT', url: 'crm/api/invoice-project/:entityId/bgt/revisions/:revisionId/publish'},
            'deleteRevision': {method: 'DELETE', url: 'crm/api/invoice-project/:entityId/bgt/revisions/:revisionId'}
        });
    })
    .service('InvoiceProjectBgtService', function ($rootScope, $cookies, toastr, modals, Principal, InvoiceProjectBgt) {
        this.add = (entityId, revisionId, totalsByCurrency) => {
            let entity = {
                entityId: entityId,
                revisionId: revisionId,
                totalsByCurrency: totalsByCurrency,
            }
            return modals.open('app/invoice/invoice-project/bgt/edit-position.html', 'InvoiceProjectBgtEditPositionController', entity, {size: "sm"}, "$ctrl")
        }
        this.edit = (entityId, revisionId, item, totalsByCurrency) => {
            let entity = {
                item: item,
                entityId: entityId,
                revisionId: revisionId,
                totalsByCurrency: totalsByCurrency
            }
            return modals.open('app/invoice/invoice-project/bgt/edit-position.html', 'InvoiceProjectBgtEditPositionController', entity, {size: "sm"}, "$ctrl")
        }
        this.delete = (entityId, revisionId, item) => {
            return modals.confirmDelete("wybraną pozycję", () => InvoiceProjectBgt.delete({entityId: entityId, revisionId: revisionId, id: item.id}).$promise)
        }
    })
